/*=========================================================================================
  File Name: moduleActivityMutations.js
  Description: Activity Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix MAsa

==========================================================================================*/

export default {
	ADD_ACTIVITY_ITEM(state, activity) {
		state.activities.unshift(activity);
	},
	SET_ACTIVITIES(state, activities) {
		state.activities = activities || [];
	},
	UPDATE_ACTIVITY(state, activity) {
		const activityIndex = state.activities.findIndex((p) => p.id === activity.id);
		Object.assign(state.activities[activityIndex], activity);
	},
	REMOVE_ACTIVITY_ITEM(state, itemId) {
		const ItemIndex = state.activities.findIndex((p) => p.id === itemId);
		state.activities.splice(ItemIndex, 1);
	},
	SET_FORMS_ACTIVITIES(state, formActivities) {
		state.formActivityOptions = formActivities;
	},
	SET_ASSIGNED_ACTIVITIES(state, activities) {
		const concatArray = activities.filter(
			(act) => !state.assignedActivities.some((assAct) => assAct.id === act.id)
		);
		state.assignedActivities = [...concatArray, ...state.assignedActivities];
	},
	REMOVE_ASSIGNED_ACTIVITY(state, id) {
		const itemIndex = state.assignedActivities.findIndex((activity) => activity.id === id);
		state.assignedActivities.splice(itemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_ACTIVITY(state) {
		state.assignedActivities = [];
	},
};
